import { render, staticRenderFns } from "./excess-form.vue?vue&type=template&id=25115662&scoped=true&"
import script from "./excess-form.vue?vue&type=script&lang=js&"
export * from "./excess-form.vue?vue&type=script&lang=js&"
import style0 from "./excess-form.vue?vue&type=style&index=0&id=25115662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25115662",
  null
  
)

export default component.exports